// O código do WhatsApp sai pela API Oficial, e o servidor espera até 30 s pela resposta dela (Pedro, 26/10/2026): as
// telas que pedem o código avisam a espera.
export const CODIGO_CHEGA_EM_30S = "O código chega no seu WhatsApp em até 30 segundos.";
export const ELE_CHEGA_EM_30S = "Ele chega em até 30 segundos.";
